/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * The key for the GC tree in summary.
 *
 * @internal
 */
export const gcTreeKey = "gc";
/**
 * The prefix for GC blobs in the GC tree in summary.
 *
 * @internal
 */
export const gcBlobPrefix = "__gc";
/**
 * The key for tombstone blob in the GC tree in summary.
 *
 * @internal
 */
export const gcTombstoneBlobKey = "__tombstones";
/**
 * The key for deleted nodes blob in the GC tree in summary.
 *
 * @internal
 */
export const gcDeletedBlobKey = "__deletedNodes";
/**
 * The key for the GC Data blob in attach summaries.
 *
 * @internal
 */
export const gcDataBlobKey = ".gcdata";
//# sourceMappingURL=garbageCollectionDefinitions.js.map